export interface LiveStream {
  id: string;
  title: string;
  host: string;
  handle: string;
  category: string;
  thumbnail_url: string;
  viewers: number;
  platform: 'youtube' | 'tiktok' | 'instagram' | 'linkedin' | 'google';
  status: 'live' | 'upcoming';
  scheduled_at: string | null;
  link_url: string;
  products: string;
}

export const liveStreams: LiveStream[] = [
  {
    id: 'live-1',
    title: 'Hodako TV — Débat showbiz en direct',
    host: 'Hodako TV',
    handle: '@hodakotv2288',
    category: 'Showbiz',
    thumbnail_url:
      'https://readdy.ai/api/search-image?query=African%20showbiz%20host%20leading%20a%20live%20entertainment%20debate%20panel%20in%20a%20colorful%20studio%20with%20neon%20lights%20and%20multiple%20guests%20warm%20energetic%20lighting%20professional%20live%20broadcast%20scene%20rich%20warm%20tones%20high%20detail&width=1280&height=720&seq=live-1&orientation=landscape',
    viewers: 12400,
    platform: 'tiktok',
    status: 'live',
    scheduled_at: null,
    link_url: 'https://www.tiktok.com/@hodakotv2288',
    products: '',
  },
  {
    id: 'live-2',
    title: 'TV7 — Journal et actualités en direct',
    host: 'TV7',
    handle: '@donnetv7',
    category: 'Actu',
    thumbnail_url:
      'https://readdy.ai/api/search-image?query=African%20news%20anchor%20presenting%20live%20current%20affairs%20in%20a%20modern%20television%20studio%20with%20a%20large%20screen%20backdrop%20professional%20lighting%20warm%20tones%20live%20broadcast%20scene%20rich%20warm%20amber%20tones%20high%20detail&width=1280&height=720&seq=live-2&orientation=landscape',
    viewers: 8700,
    platform: 'tiktok',
    status: 'live',
    scheduled_at: null,
    link_url: 'https://www.tiktok.com/@donnetv7',
    products: '',
  },
  {
    id: 'live-3',
    title: 'Sethlo — Session live acoustique',
    host: 'Sethlo',
    handle: '@sethloofficiel',
    category: 'Musique',
    thumbnail_url:
      'https://readdy.ai/api/search-image?query=African%20rapper%20performing%20an%20intimate%20acoustic%20live%20session%20with%20a%20microphone%20and%20warm%20studio%20lighting%20cozy%20atmosphere%20candles%20and%20soft%20golden%20glow%20rich%20warm%20tones%20high%20detail&width=1280&height=720&seq=live-3&orientation=landscape',
    viewers: 5600,
    platform: 'youtube',
    status: 'live',
    scheduled_at: null,
    link_url: 'https://www.youtube.com/channel/UC094OS-HL9VZX0YptTMp1Xw',
    products: 'T-shirts & casquettes, Albums dédicacés, Places de concert',
  },
  {
    id: 'live-4',
    title: 'Joachim Migos — Live studio avant le concert',
    host: 'Joachim Migos',
    handle: '@joachinmigos',
    category: 'Musique',
    thumbnail_url:
      'https://readdy.ai/api/search-image?query=African%20rap%20artist%20in%20a%20recording%20studio%20preparing%20for%20a%20live%20session%20with%20microphone%20headphones%20and%20warm%20dramatic%20lighting%20moody%20atmosphere%20rich%20warm%20amber%20tones%20high%20detail&width=1280&height=720&seq=live-4&orientation=landscape',
    viewers: 0,
    platform: 'youtube',
    status: 'upcoming',
    scheduled_at: '2026-09-19',
    link_url: 'https://www.youtube.com/@JoachinMigosOfficial',
    products: 'Vinyles collectors, Merch exclusif',
  },
  {
    id: 'live-5',
    title: 'Toofan — Live studio : préparation du concert anniversaire',
    host: 'Toofan',
    handle: '@toofanofficiel',
    category: 'Musique',
    thumbnail_url:
      'https://readdy.ai/api/search-image?query=African%20afropop%20duo%20rehearsing%20in%20a%20music%20studio%20with%20colorful%20lights%20and%20energetic%20choreography%20warm%20vibrant%20lighting%20professional%20live%20session%20scene%20rich%20golden%20tones%20high%20detail&width=1280&height=720&seq=live-5&orientation=landscape',
    viewers: 0,
    platform: 'instagram',
    status: 'upcoming',
    scheduled_at: '2026-10-30',
    link_url: 'https://www.instagram.com/toofanofficiel',
    products: 'Billets VIP, Packs rencontres artistes',
  },
  {
    id: 'live-6',
    title: 'Ralycia — Live acoustique intime',
    host: 'Ralycia',
    handle: '@ralyciaofficiel',
    category: 'Musique',
    thumbnail_url:
      'https://readdy.ai/api/search-image?query=Soulful%20African%20female%20singer%20performing%20a%20warm%20intimate%20live%20session%20with%20soft%20candlelight%20and%20acoustic%20guitar%20elegant%20atmosphere%20rich%20warm%20golden%20tones%20high%20detail&width=1280&height=720&seq=live-6&orientation=landscape',
    viewers: 0,
    platform: 'youtube',
    status: 'upcoming',
    scheduled_at: '2026-11-08',
    link_url: 'https://www.youtube.com/channel/UCEplISzIDYTVTpJKhh5tAgQ',
    products: 'Albums CD signés, Bracelets artisanaux',
  },
];